module.exports = __webpack_public_path__ + "img/ecart-pay.9fc2fcc0.svg";